import { sortBy } from 'lodash';

export const sortOptions = (options: IOptionType[]): IOptionType[] => {
  return sortBy(options, (item) => item.label);
};
